module.exports = __webpack_public_path__ + "static/media/CargoCompactOnline_GeneralCondition_de.5a4b2e78.pdf";